import { useEffect, useState } from "react";
import { Space, Select, Button, Spin } from "antd";
import { DatePickerPopover } from "../../components/DatePickerPopover";
// import { setOpenInfo } from "../../store/user";
// import { InfoModal } from "../../components/InfoModal";
import { convertDateToISO861, convertToLocalDate } from "../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { clearErrorStudio } from "../../store/studios";
import { getStudioData, getErrorStudio } from "../../store/studios/selectors";
import {
  getEmployeesSalary,
  getStaffEmployeesSalaryDropDown,
  clearError,
  clearSuccess,
  clearData,
} from "../../store/employeesSalary";
import {
  getEmployeesSalaryData,
  getEmployeesSalaryLoading,
  getError,
  getSuccess,
  getStaffEmployeesSalaryDropDownSelector,
} from "../../store/employeesSalary/selectors";
import displayErrors from "../../utils/displayErrors";
import { getFirstDayAndCurrentDateOfCurrentMonth } from "../../utils/getFirstDayAndCurrentDateOfCurrentMonth";
import { CollapseCorrections } from "../../components/CollapseCorrections";
import { CollapseBounty } from "../../components/CollapseBounty";
import { CollapseSalary } from "../../components/CollapseSalary";
import { CollapsePayments } from "../../components/CollapsePayments";

export const EmployeesSalaryPage = () => {
  const dispatch = useDispatch();
  const studioData = useSelector(getStudioData);
  const error = useSelector(getError);
  const isLoading = useSelector(getEmployeesSalaryLoading);
  const errorStudio = useSelector(getErrorStudio);
  const employeesSalaryData = useSelector(getEmployeesSalaryData);
  const [width, setWidth] = useState(window.innerWidth);
  const { firstDay, currentDay } = getFirstDayAndCurrentDateOfCurrentMonth();
  const formatDate = (date) => convertToLocalDate(date).split(" ")[0];
  const [dateAfterFilter, setDateAfterFilter] = useState(formatDate(firstDay));
  const [dateBeforeFilter, setDateBeforeFilter] = useState(
    formatDate(currentDay)
  );
  const [openDate, setOpenDate] = useState(false);
  const [viewDataFilter, setViewDataFilter] = useState(
    `${formatDate(firstDay)} - ${formatDate(currentDay)}`
  );
  const success = useSelector(getSuccess);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const staffList = useSelector(getStaffEmployeesSalaryDropDownSelector);

  const fetchData = () => {
    let filters = {};

    if (dateAfterFilter || dateBeforeFilter) {
      filters = {
        start_date: convertDateToISO861(dateAfterFilter),
        end_date: convertDateToISO861(dateBeforeFilter),
      };
    }
    dispatch(clearSuccess());
    dispatch(clearError());
    dispatch(clearErrorStudio());
    if (dateAfterFilter && dateBeforeFilter && selectedStaff) {
      dispatch(
        getEmployeesSalary({
          studio_y_id:
            JSON.parse(sessionStorage.getItem("studio"))?.y_id ||
            studioData?.y_id,
          staff_id: selectedStaff,
          filters: filters,
        })
      );
    }
  };

  const clearFilters = () => {
    setSelectedStaff(null);
    dispatch(clearData());
  };

  useEffect(() => {
    if (studioData) {
      const timerRefresh = setTimeout(fetchData, 0);
      return () => {
        clearTimeout(timerRefresh);
      };
    }
  }, [
    // dateAfterFilter,
    // dateBeforeFilter,
    studioData,
    success,
    selectedStaff,
  ]);

  useEffect(() => {
    if (studioData) {
      dispatch(
        getStaffEmployeesSalaryDropDown({ studio_y_id: studioData?.y_id })
      );
    }
  }, [studioData?.y_id]);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
  }, [width]);

  return (
    <>
      <div
        style={{
          display: "flex",
          gap: width > 640 ? 12 : 9,
          position: "relative",
          paddingBottom: width > 640 ? 25 : 16,
          flexDirection: width > 640 ? "row" : "column",
        }}
      >
        <div style={{ display: "flex", alignItems: "end" }}>
          <DatePickerPopover
            openDate={openDate}
            setOpenDate={setOpenDate}
            viewDataFilter={viewDataFilter}
            setViewDataFilter={setViewDataFilter}
            dateAfterFilter={dateAfterFilter}
            dateBeforeFilter={dateBeforeFilter}
            setDateAfterFilter={setDateAfterFilter}
            setDateBeforeFilter={setDateBeforeFilter}
            fetchData={fetchData}
          />
        </div>
        <div
          style={{ display: "flex", alignItems: "end", gap: 9, width: "100%" }}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <Select
              allowClear={true}
              showSearch={true}
              optionFilterProp="label"
              placeholder="Сотрудник"
              style={{ width: "100%", textAlign: "left" }}
              options={staffList?.map((option) => {
                return {
                  value: option.id,
                  label: option.y_name,
                };
              })}
              value={selectedStaff}
              onChange={setSelectedStaff}
            />
          </Space>

          {selectedStaff && (
            <Button
              onClick={clearFilters}
              style={{ borderRadius: 2, backgroundColor: "#4D7CD6" }}
              type={"primary"}
            >
              Сбросить
            </Button>
          )}
        </div>
      </div>
      {(error || errorStudio) && displayErrors(error || errorStudio)}
      {isLoading ? (
        <div
          style={{
            height: "calc(100vh - 107px)",
            alignContent: "center",
            justifySelf: "center",
          }}
        >
          <Spin />
        </div>
      ) : employeesSalaryData ? (
        <div style={{ height: "calc(100vh - 200px)", overflow: "auto" }}>
          <CollapseSalary
            salary={employeesSalaryData?.salary}
            sum={employeesSalaryData?.salary?.total}
            width={width}
          />
          <CollapseBounty
            data={employeesSalaryData?.bounty?.corrections}
            sum={employeesSalaryData?.bounty?.total}
            width={width}
          />
          <CollapseCorrections
            data={employeesSalaryData?.corrections?.corrections}
            sum={employeesSalaryData?.corrections?.total}
            width={width}
          />
          <CollapsePayments
            data={employeesSalaryData?.prepayment}
            sum={employeesSalaryData?.prepayment?.total}
            width={width}
          />
        </div>
      ) : (
        <h1
          style={{
            color: "#8B8B8B",
            fontWeight: 400,
            textAlign: "center",
            fontSize: width < 640 && 20,
          }}
        >
          Выберите сотрудника
        </h1>
      )}
    </>
  );
};
